import _extends from "@babel/runtime/helpers/extends";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import ImageWithLoader from './ImageWithLoader';
function LazyImage(_ref) {
  var otherProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(ImageWithLoader, _extends({
    loading: "lazy"
  }, otherProps));
}
export { ImageWithLoader };
export default LazyImage;